import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
	constructor(private router: Router, private authenticationService: AuthService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const user = this.authenticationService.getCurrentUser();
		if (user) return true;
		// not logged in so redirect to login page with the return url
		this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
		return false;
	}

	canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.canActivate(next, state);
	}

	canDeactivate(
		component: unknown,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState?: RouterStateSnapshot
	) {
		return true;
	}
}
